import styled from "styled-components";
import MoonLoader from "react-spinners/MoonLoader";

import { BUNNYNET_VIDEO_THUMBNAIL_DOMAIN } from "constants";
import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import InputWithLabel from "components/forms/InputWithLabel";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";
import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";
import ModalWrap from "components/other/ModalWrap";
import Backdrop from "components/other/Backdrop";
import ModalWindow from "components/other/ModalWindow";
import ButtonWhite from "components/buttons/ButtonWhite";
import ButtonPrimary from "components/buttons/ButtonPrimary";

import binIcon from "assets/img/icons/bin-icon.svg";
import binWhiteIcon from "assets/img/icons/bin-icon-white.svg";
import clockIcon from "assets/img/icons/Circle-Clock-Black-Icon.svg";

const Media = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0;
  padding: 0;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    padding: 0;
  }
`;

const MediaBox = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const BoxTitle = styled.div`
  width: 100%;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};

  display: flex;
  flex-direction: column;
`;

const Text = styled.div`
  line-height: 125%;
`;

const FileForm = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
`;

const Warning = styled.div`
  margin-top: 7px;

  font-size: 13px;
  font-weight: 500;
  color: ${css.ERROR_RED};
`;

const FileInput = styled.input`
  width: 100%;
  height: 42px;
  box-sizing: border-box;

  border: 0px;
  border-radius: 15px;

  background: ${css.DARK_BOX_BACKGROUND};

  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-weight: 300;
  color: #ffffff;

  &::file-selector-button {
    margin: 7px 14px 0 10px;
    height: 28px;
    padding: 0 15px;

    border: 0;
    border-radius: 14px;
    cursor: pointer;
    background: ${css.BRAND_YELLOW};

    transition: 0.2s;

    font-family: "Barlow";
    font-size: 13px;
    font-weight: 500;
  }

  &::file-selector-button:hover {
    color: #fff;

    background: ${css.BRAND_GREEN};
  }
`;

const FileInputSection = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  gap: 10px;
`;

const UploadButtonWrap = styled.div``;

const UploadProgress = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN};

  display: flex;
  align-items: center;
  gap: 10px;
`;

const UploadProgressLoadingBox = styled.div``;

const UploadProgressText = styled.div`
  min-width: 110px;
`;

const UploadProgressBar = styled.div`
  position: relative;

  height: 20px;
  border-radius: 10px;
  overflow: hidden;

  background-color: ${css.BRAND_INDIGO};

  flex: 1;
`;

const UploadProgressInsideBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => props.width}%;
  height: 100%;

  background-color: ${css.BRAND_GREEN};
`;

const FileList = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN};

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const File = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const FileThumbnail = styled.div`
  width: 60px;
  min-width: 60px;
  height: 48px;

  background-color: rgba(238, 229, 233, 0.5);

  border: 1px solid rgba(238, 229, 233, 0.5);
  border-radius: 10px;

  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ClockIcon = styled.div`
  width: 22px;
  height: 22px;
`;

const FileName = styled.div`
  max-width: 360px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StatusBadge = styled.div`
  height: 20px;
  padding: 0 14px 1px;

  font-size: 13px;
  color: #fff;
  white-space: nowrap;

  border-radius: 10px;
  background: ${css.BRAND_INDIGO};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const ConfirmDelete = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: auto;
  transform: translateX(-50%) translateY(-50%);

  width: 100%;
  max-width: 442px;
  padding: 0 10px;
  box-sizing: border-box;
  z-index: 200;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${globalConstants.switchMobile}) {
    width: 100%;
  }
`;

const ConfirmDeleteWrap = styled.div`
  margin-top: 60px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ConfirmDeleteText = styled.div`
  line-height: 140%;
`;

const ConfirmDeleteButtons = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_XLARGE};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${css.BUTTONS_GAP};
`;

export default ({
  data,
  onFileInputChange,
  warnings,
  fileInputRef,
  fileInputKey,
  showUploadButton,
  onUploadClick,
  uploadLoading,
  uploadProgress,
  onDeleteClick,
  confirmDeleteMedia,
  closeDeleteModal,
  onConfirmDelete,
  uploadErrorMessage,
}) => {
  const list = data.mediaData.map((file) => {
    const videoAge =
      (new Date().getTime() - new Date(file.created_at).getTime()) / 1000;

    const showThumbnail = videoAge >= 180;

    const thumbnailUrl =
      BUNNYNET_VIDEO_THUMBNAIL_DOMAIN + "/" + file.video_id + "/thumbnail.jpg";

    return (
      <File id={file.id}>
        <FileThumbnail>
          {showThumbnail ? (
            <Thumbnail src={thumbnailUrl} />
          ) : (
            <ClockIcon>
              <img src={clockIcon} style={{ width: "100%" }} />
            </ClockIcon>
          )}
        </FileThumbnail>
        <FileName>{file.original_name}</FileName>
        {file.status === "inReview" && <StatusBadge>In Review</StatusBadge>}
        <ButtonRoundIcon
          icon={binIcon}
          hoverIcon={binWhiteIcon}
          background={css.BRAND_YELLOW}
          hoverBackground={css.NEGATIVE_RED}
          onClick={() => onDeleteClick(file.id)}
          buttonSize="34px"
          iconSize="15px"
        />
      </File>
    );
  });

  let mediaToDelete;

  if (data && confirmDeleteMedia) {
    mediaToDelete = data.mediaData.find(
      (media) => media.id === confirmDeleteMedia
    );
  }

  return (
    <Media>
      <MediaBox>
        <BoxTitle>Videos</BoxTitle>
        <Text>Insert the video you want to use in your post.</Text>
        <FileForm>
          <InputWithLabel
            label="Add Video File"
            width="100%"
            marginTop={css.VERTICAL_BOX_MARGIN}
          >
            <FileInputSection>
              <FileInput
                type="file"
                accept="video/*"
                onChange={onFileInputChange}
                ref={fileInputRef}
                key={fileInputKey}
              />
              {showUploadButton && (
                <UploadButtonWrap>
                  <ButtonPrimarySmall
                    onClick={onUploadClick}
                    disabled={uploadLoading}
                  >
                    Upload
                  </ButtonPrimarySmall>
                </UploadButtonWrap>
              )}
            </FileInputSection>
          </InputWithLabel>
          {warnings.includes("fileTooLarge") && (
            <Warning>
              The selected file is too large. The maximum allowed size is 100
              MB.
            </Warning>
          )}
          {uploadErrorMessage && <Warning>{uploadErrorMessage}</Warning>}
          {uploadLoading && (
            <UploadProgress>
              <UploadProgressLoadingBox>
                <MoonLoader color="rgba(255,255,255,1)" size={20} />
              </UploadProgressLoadingBox>
              <UploadProgressText>
                Uploading {uploadProgress}%
              </UploadProgressText>
              <UploadProgressBar>
                <UploadProgressInsideBar width={uploadProgress} />
              </UploadProgressBar>
            </UploadProgress>
          )}
        </FileForm>
        <FileList>{list}</FileList>
        {mediaToDelete && (
          <ModalWrap>
            <Backdrop
              onClick={closeDeleteModal}
              background="rgba(0, 0, 0, 0.7)"
            />
            <ConfirmDelete>
              <ModalWindow
                title="Delete Post"
                handleModalClose={closeDeleteModal}
                fullScreenHeight={true}
              >
                <ConfirmDeleteWrap>
                  <ConfirmDeleteText>
                    Do you really want to delete the video "
                    {mediaToDelete.original_name}
                    "?
                  </ConfirmDeleteText>
                  <ConfirmDeleteButtons>
                    <ButtonWhite onClick={closeDeleteModal}>Cancel</ButtonWhite>
                    <ButtonPrimary onClick={onConfirmDelete}>
                      Delete
                    </ButtonPrimary>
                  </ConfirmDeleteButtons>
                </ConfirmDeleteWrap>
              </ModalWindow>
            </ConfirmDelete>
          </ModalWrap>
        )}
      </MediaBox>
    </Media>
  );
};
